$('.article-toc-nav .toc-heading').on('click', function () {
  var currentEvent = $(this);
  if (currentEvent.parent().hasClass('active')) {
    currentEvent.find('+div').slideUp(150, function () {
      currentEvent.parent().removeClass('active');
    });
  } else {
    currentEvent.find('+div').slideDown(150, function () {
      $(this).css('display', 'flex');
      var activeItem = currentEvent.parent().parent().find('.active');
      activeItem.find('.toc-list').slideUp(150);
      activeItem.removeClass('active');
      currentEvent.parent().addClass('active');
    });
  }
});
$('.article-toc-nav .toc-item-h2').on('click', function () {
  var currentEvent = $(this);
  if (currentEvent.hasClass('active')) {
    currentEvent.find('+.toc-h3-wrapper').slideUp(150, function () {
      currentEvent.removeClass('active');
    });
  } else {
    currentEvent.parent().find('.toc-h3-wrapper').slideUp(150);
    currentEvent.parent().find('.active').removeClass('active');
    currentEvent.find('+.toc-h3-wrapper').slideDown(150, function () {
      $(this).css('display', 'flex');
      currentEvent.addClass('active');
    });
  }
});

// 目录项按 data-heading-index（标题在正文中的序号，空标题也计数，Liquid 端生成）直接取正文里第 N 个 h2/h3。
// 不按 id 找：id 由 article-anchors.js 稍后补，且作者可能写了重复 id；也不按"第几个非空标题"数：
// Liquid 的 strip 和 DOM 的 trim 对 &nbsp; 等空白判定不同，按那个序号对会错位。
// 没有 data-heading-index 时（如旧缓存页）退回原逻辑：.rte 下同级标题按 num 取
function articleTocTarget(item) {
  var $item = $(item);
  var tag = $item.attr('tag');
  var index = parseInt($item.attr('data-heading-index'), 10);
  if (index > 0) return $(`.article-template__content-rte ${tag}`).eq(index - 1);
  return $(`.rte ${tag}`).eq($item.attr('num'));
}

$('.article-toc-nav .toc-item-h2 p,.article-toc-nav .toc-item-h3').on('click', function (event) {
  event.stopPropagation();
  var $target = articleTocTarget(this);
  if (!$target.length) return;
  windowScrollTop($target, ['.section-countdown-timer-bar', 'header.header', '.section-progress-bar']);
})

// 滚动时高亮当前所在章节（只标 h2，不自动展开 h3，避免吸顶目录跳动）
;(function () {
  var pairs = $('.article-toc-nav .toc-item-h2').map(function () {
    var $target = articleTocTarget($(this).children('p'));
    return $target.length ? { item: this, heading: $target[0] } : null;
  }).get();
  if (!pairs.length) return;
  var current = null;
  var ticking = false;

  function update() {
    ticking = false;
    var offset = (parseInt($('header.header').outerHeight()) || 0) + 120;
    var active = null;
    for (var i = 0; i < pairs.length; i++) {
      if (pairs[i].heading.getBoundingClientRect().top - offset <= 0) active = pairs[i].item;
      else break;
    }
    if (active === current) return;
    if (current) $(current).removeClass('is-current');
    if (active) $(active).addClass('is-current');
    current = active;
  }

  $(window).on('scroll resize', function () {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  });
  update();
})();
